import {FONT_FAMILY_PROXIMA, FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {
  BLUE,
  BLUE_POWDER,
  BLUE_LIGHT,
  GRAY,
  GRAY_DARK,
  GRAY_DARKER,
  GRAY_LIGHT,
  GREEN,
  GREEN_DARK,
  LIME,
  NEAR_BLACK,
  ORANGE,
  RED,
  RED_LIGHT,
  WHITE,
} from 'ui-library/Colors';

// Make sure adjacent colors are visually distinguishable (good: [BLUE, RED], bad: [BLUE, BLUE_DARKER]).
export const CHART_COLORS_DISCRETE_PALETTE = [
  BLUE,
  RED_LIGHT,
  ORANGE,
  GREEN_DARK,
  LIME,
  BLUE_LIGHT,
  RED,
  '#EAC76C',
  '#0C8697',
  '#A2B9BE',
  '#5293FF',
  '#FF7280',
  '#FFCB90',
  '#90DED6',
  '#C9E4EB',
  '#6BA1FF',
  '#FF949F',
  '#CA4F28',
  '#57AFC2',
  '#E5BFEE',
  '#7387CF',
  '#FFCF52',
  '#8B271C',
  '#67B897',
  '#B459B6',
  '#B5C5FF',
  '#5F44AD',
  '#879CA0',
  '#8ACFCB',
  '#3C5A62',
];
export const CHART_COLORS_GRADIENT_PALETTE = [LIME, BLUE];
export const CHART_COLORS_NO_LABEL_COLOR = BLUE;

export const LABEL_FONT_SIZE = FONT_PROXIMA_13.fontSize;
export const LABEL_LINE_HEIGHT = FONT_PROXIMA_13.lineHeight;
export const LABEL_HEIGHT = LABEL_FONT_SIZE * LABEL_LINE_HEIGHT;
export const TICK_LABEL_TO_AXIS = 8;
// Rotated labels should be placed closer to the axis, as they appear further away
export const ROTATED_TICK_LABEL_TO_AXIS = TICK_LABEL_TO_AXIS / 2;
export const AXIS_LABEL_TO_TICK_LABEL = 11;
export const ASSUMED_TICK_LABEL_LENGTH = 30; // Assume a default tick label length that will be overridden for longer ticks
export const TICK_LABEL_TO_CHART_EDGE = 3;
export const AXIS_LABEL_TO_CHART_EDGE = 3;

export const DEFAULT_SUGGESTED_NUM_TICKS = 8;

export const BENCHLING_CHART_MARGIN = 5;
export const DEFAULT_CHART_MARGIN = 20 - BENCHLING_CHART_MARGIN;
export const DEFAULT_X_AXIS_MARGIN_WITHOUT_LABEL = TICK_LABEL_TO_AXIS + LABEL_FONT_SIZE;
export const DEFAULT_X_AXIS_MARGIN_WITH_LABEL =
  DEFAULT_X_AXIS_MARGIN_WITHOUT_LABEL + AXIS_LABEL_TO_TICK_LABEL + LABEL_FONT_SIZE;
export const DEFAULT_CARTESIAN_CHART_MARGINS = {
  top: DEFAULT_CHART_MARGIN,
  right: DEFAULT_CHART_MARGIN,
  bottom: DEFAULT_X_AXIS_MARGIN_WITH_LABEL,
  left: LABEL_FONT_SIZE + AXIS_LABEL_TO_TICK_LABEL + ASSUMED_TICK_LABEL_LENGTH + TICK_LABEL_TO_AXIS,
};

export const POINT_RADIUS = 4;

export const DEFAULT_AXIS_LINE_STYLE = {
  strokeWidth: 1,
  stroke: GRAY,
};

export const DEFAULT_GRID_LINE_STYLE = {
  strokeWidth: 1,
  stroke: GRAY_LIGHT,
};

export const DEFAULT_LABEL_STYLE = {
  fontSize: LABEL_FONT_SIZE,
  lineHeight: LABEL_LINE_HEIGHT,
  fontFamily: FONT_FAMILY_PROXIMA,
  fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  fill: NEAR_BLACK,
};

export const ERROR_BAR_LINE_WIDTH = 1.5;
export const NO_SERIES_ERROR_BAR_COLOR = NEAR_BLACK;

export const LEGEND_ITEM_HOVER_BACKGROUND = GRAY_LIGHT;
export const LEGEND_ITEM_EXCLUDED_COLOR = GRAY_DARK;

export const MASKED_SCATTER_PLOT_POINT_COLOR = GRAY;
export const OUTLIER_SCATTER_PLOT_POINT_COLOR = '#FC6535';
export const EXCLUDED_OUTLIER_SCATTER_PLOT_POINT_COLOR = '#ECCFC7';

export const HEATMAP_COLORS = [BLUE_POWDER, BLUE];
export const HEATMAP_MASK_FILL_COLOR = GRAY_DARKER;
export const HEATMAP_MASK_CROSS_COLOR = GRAY_DARK;
export const NULL_FILL_COLOR = WHITE;

export const REGRESSION_LINE_COLOR = GREEN;
